// Minicart & Cart Page Shipping Progress Bar
function shipping_progress_bar() {
  let shopify_country = Shopify.country;
  let store_symbol =
    document.body.getAttribute("data-money-format") || "$";
  let before_symbol = store_symbol.split("{")[0] || "";
  let after_symbol = (store_symbol.split("}}")[1] || "").trim();
  let dataInput = document.getElementById("datajsonvalue");
  if (!dataInput) {
    console.error("Missing #datajsonvalue input with JSON URL");
    return;
  }
  let dataUrl = dataInput.value;
  fetch(dataUrl)
    .then((response) => response.json())
    .then((data) => {
      if (data[shopify_country]) {
        setTimeout(() => {
          let shipping_rate = parseFloat(
            data[shopify_country].free_shipping_order_value
          );
          let country_symbol = data[shopify_country].money_symbol;
          let cartElement = document.querySelector(".cart__grandtotal");

          let val = cartElement.getAttribute("data-total");
          let cart_total = cartElement
            ? parseFloat(cartElement.getAttribute("data-total"))
            : 0;
          let barEls = document.querySelectorAll(
            "#myBar, .custom-minicart #myBar, .section--cart-page #myBar"
          );
          let msgEls = document.querySelectorAll(".shipping-msg");
          msgEls.forEach((msgEl) => {
            if (shipping_rate > val) {
              let ship_amt = (shipping_rate - cart_total).toFixed(2);
              let shipping_percent = (
                (cart_total / shipping_rate) *
                100
              ).toFixed(2);

              msgEl.innerHTML = `Shop for <b>${country_symbol} ${ship_amt} </b> more for <b>FREE SHIPPING !</b>`;
              document
                .querySelectorAll(".myProgress-wrap #myBar")
                .forEach((el) => {
                  el.style.width = shipping_percent + "%";
                });
            } else {
              msgEl.innerHTML = `<b>FREE SHIPPING !</b>`;
              barEls.forEach((el) => (el.style.width = "100%"));
            }
          });
        }, 1500);
      }
    })
    .catch((err) => {
      console.error("Error loading JSON", err);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("booster:cart:update", function (e) {
    shipping_progress_bar();
  });
});

// PDP Free Delivery Message
function free_delivery_message() {
  var shopify_country = Shopify.country;
  let dataInput = document.getElementById("datajsonvalue");
  if (!dataInput) {
    console.error("Missing #datajsonvalue input with JSON URL");
    return;
  }
  let dataUrl = dataInput.value;

  fetch(dataUrl)
    .then((response) => response.json())
    .then((data) => {
      if (data[shopify_country]) {
        setTimeout(() => {
          let shipping_rate = parseFloat(
            data[shopify_country].free_shipping_order_value
          );
          let country_symbol = data[shopify_country].money_symbol;
          const freeDeliveryEls = document.querySelectorAll("#free_delivery");
          freeDeliveryEls.forEach((freeDeliveryEl) => {
            freeDeliveryEl.innerHTML = `<b>FREE shipping</b> on orders over <b>${country_symbol}${shipping_rate.toFixed(
              2
            )}</b>`;
          });
        }, 1500);
      }
    })
    .catch((error) =>
      console.error("Error fetching free delivery data:", error)
    );
}


function shippingRates() {
  if (window.location.pathname.indexOf("/products") !== -1) {
    var shippingdata_json = $("#shippingdata_json").val();

    if (shippingdata_json) {
      try {
        var shippingdatajson = JSON.parse(shippingdata_json);
        var userCountryCode = Shopify.country || "US";
        var countryData = shippingdatajson[userCountryCode];
        if (!countryData) {
          console.warn("No shipping data for", userCountryCode);
          return;
        }
        var userCurrency = countryData["currency info"]["currency"];
        var userCurrencySymbol = countryData["currency info"]["symbol"];

        var cheapestMethod = countryData["cheapest shipping method"];
        var shippingRates =
          countryData["shipping rates"][cheapestMethod]["rates"];

        var shippingratestable = `
          <table>
            <tr><td>Cart Value (${userCurrency})</td></tr>
            <tr><td>Shipping Rates (${userCurrency})</td></tr>
          </table>`;

        $(".shipping_rates").html(shippingratestable);

        var tdStringOne = "";
        var tdStringTwo = "";

        $.each(shippingRates, function (keyIn, valueIn) {
          var min_cart_price = valueIn["min cart price"];
          var max_cart_price = valueIn["max cart price"];
          var shipping_price = valueIn["shipping price"];

          if (max_cart_price === "None") {
            max_cart_price = "";
          } else {
            max_cart_price = userCurrencySymbol + max_cart_price;
          }

          if (min_cart_price === 0) {
            min_cart_price = "";
            max_cart_price = "Less than " + max_cart_price;
          } else if (shipping_price === 0) {
            min_cart_price =
              "Greater than " + userCurrencySymbol + min_cart_price;
          } else {
            min_cart_price = userCurrencySymbol + min_cart_price + "-";
          }

          if (shipping_price === 0) {
            shipping_price =
              '<span style="color:purple;font-size:15px">FREE</span>';
          } else {
            shipping_price = userCurrencySymbol + shipping_price;
          }

          tdStringOne =
            "<td>" +
            min_cart_price +
            "" +
            max_cart_price +
            "</td>" +
            tdStringOne;
          tdStringTwo = "<td>" + shipping_price + "</td>" + tdStringTwo;
        });

        $(".shipping_rates tr:first").append(tdStringOne);
        $(".shipping_rates tr:nth-child(2)").append(tdStringTwo);
      } catch (e) {
        console.error("Invalid JSON", e, shippingdata_json);
      }
    }
  }
}

function changeTimeZone(date, timeZone) {
  if (typeof date === "string") {
    return new Date(
      new Date(date).toLocaleString("en-US", {
        timeZone,
      })
    );
  }

  return new Date(
    date.toLocaleString("en-US", {
      timeZone,
    })
  );
}

function deliveryBy(fromDate, toDate, isFirstTime) {

  var product_delivery_cutoff_time = $("#product_delivery_cutoff_time").val();

  var cutOffDate = null;
  if (product_delivery_cutoff_time) {
    try {
      var productDeliveryCutoffTime = JSON.parse(product_delivery_cutoff_time);

      cutOffDate = changeTimeZone(
        new Date(),
        productDeliveryCutoffTime["timezone"]
      );
      cutOffDate.setHours(
        productDeliveryCutoffTime["hours"],
        productDeliveryCutoffTime["minutes"],
        productDeliveryCutoffTime["seconds"]
      );
    } catch (e) {
      console.error("❌ Invalid cutoff JSON:", e, product_delivery_cutoff_time);
    }
  }

  if (!cutOffDate) {
    cutOffDate = changeTimeZone(new Date(), "Asia/Kolkata");
    cutOffDate.setHours(14, 30, 0);
  }

  var userTimezone = mapCountryToTimezone(Shopify.country);
  cutOffDate = changeTimeZone(cutOffDate, userTimezone);

  setInterval(function () {
    const currenDate = changeTimeZone(new Date(), userTimezone);
    var removeFrom24Hours = false;
    if (cutOffDate <= currenDate) {
      removeFrom24Hours = true;
    }

    var diffMillis =
      cutOffDate > currenDate ? cutOffDate - currenDate : currenDate - cutOffDate;

    var diffSeconds = Math.floor(diffMillis / 1000);
    var hours1, minutes1, seconds1;
    var hoursStr, minutesStr, secondsStr;

    if (diffSeconds < 0) {
      diffSeconds = Math.abs(diffSeconds);
      hours1 = Math.floor((diffSeconds / (60 * 60)) % 24);
      minutes1 = Math.floor((diffSeconds / 60) % 60);
      seconds1 = Math.floor(diffSeconds % 60);
    } else {
      hours1 = Math.floor((diffSeconds / (60 * 60)) % 24);
      minutes1 = Math.floor((diffSeconds / 60) % 60);
      seconds1 = Math.floor(diffSeconds % 60);

      if (cutOffDate < currenDate) {
        hours1 = 23 - hours1;
        minutes1 = 59 - minutes1;
        seconds1 = 59 - seconds1;
        removeFrom24Hours = true;
      }
    }

    hoursStr = ("0" + hours1).slice(-2);
    minutesStr = ("0" + minutes1).slice(-2);
    secondsStr = ("0" + seconds1).slice(-2);

    if (hours1 == 0 && minutes1 == 0 && seconds1 == 0) {
      isFirstTime = true;
    }

    // Shift dates if cutoff passed
    if (removeFrom24Hours && isFirstTime) {
      fromDate.setDate(fromDate.getDate() + 1);
      toDate.setDate(toDate.getDate() + 1);

      // Avoid Saturday/Sunday
      if (fromDate.getDay() == 6) fromDate.setDate(fromDate.getDate() + 1);
      if (fromDate.getDay() == 0) fromDate.setDate(fromDate.getDate() + 1);
      if (toDate.getDay() == 6) toDate.setDate(toDate.getDate() + 1);
      if (toDate.getDay() == 0) toDate.setDate(toDate.getDate() + 1);
    }

    var startDay =
      fromDate.toLocaleString("en-US", { month: "short" }) +
      " " +
      fromDate.getDate();
    var endDay =
      toDate.toLocaleString("en-US", { month: "short" }) +
      " " +
      toDate.getDate();

    if (isFirstTime) {
      var deliveryStr =
        "Delivered between <b class=delivery_day delivery_startday>" +
        startDay +
        "</b> - <b class=delivery_day delivery_endday>" +
        endDay +
        "</b> if ordered within <b class=delivery_time>" +
        hoursStr +
        "hrs " +
        minutesStr +
        "mins.</b><span class='delivery_tooltip'><img src=//www.indiangoods.shop/cdn/shop/t/26/assets/info.svg?v=44191410146432642921757572983 /><img src=//www.indiangoods.shop/cdn/shop/t/26/assets/delivery_by_tooltip.png?v=110381582430275148011757572983 class='delivery_by_tooltip' /></span></div>";

      $(".delivery_within_txt").html(deliveryStr);
      $(".delivery_tooltip").hover(function () {
        $(".delivery_by_tooltip").show();
      });
      $(".delivery_tooltip").mouseout(function () {
        $(".delivery_by_tooltip").hide();
      });
      $(".deliverydate").html(startDay + "-" + endDay);
      isFirstTime = false;
    } else {
      $(".delivery_startday").html(startDay);
      $(".delivery_endday").html(endDay);
      $(".delivery_time").html(hoursStr + "hrs " + minutesStr + "mins.");
    }
    return [fromDate, toDate];
  }, 1000);
}

function mapCountryToTimezone(countryCode) {
  switch (countryCode) {
    case "US": return "America/New_York";
    case "CA": return "America/Toronto";
    case "GB": return "Europe/London";
    case "AU": return "Australia/Sydney";
    case "AE": return "Asia/Dubai";
    case "SA": return "Asia/Riyadh";
    case "IN": return "Asia/Kolkata";
    default:   return "Asia/Kolkata"; 
  }
}

function shippingProgress(isRapidDelivery) {
  if (window.location.pathname.indexOf("/products") != -1) {
    var shippingdata_json = $("#shippingdata_json").val();
    if (shippingdata_json != null && shippingdata_json != "") {
      var shippingdatajson = $.parseJSON(shippingdata_json);
      var userCountryCode = Shopify.country || "US";
      if (shippingdatajson[userCountryCode] && userCountryCode != "IN") {
        var shippingmethod =
          shippingdatajson[userCountryCode]["fastest shipping method"];
        var country_min_del_days =
          shippingdatajson[userCountryCode]["shipping rates"][shippingmethod][
            "min delivery days"
          ];
        var country_max_del_days =
          shippingdatajson[userCountryCode]["shipping rates"][shippingmethod][
            "max delivery days"
          ];
        var currentDate = new Date();
        var currentDateVal = currentDate.getDate();
        var orderedDate = new Date();
        var orderedDateMonth = orderedDate.toLocaleString("en-US", {
          month: "short",
        });
        var orderDate = orderedDateMonth + " " + orderedDate.getDate();
        
        if (isRapidDelivery) {
          var minShipDate = new Date();
          // find weekends and calculate shipping days
          var nextDayDelivery = true;
          while (nextDayDelivery) {
            minShipDate.setDate(minShipDate.getDate() + parseInt(1));
            if (!(minShipDate.getDay() == 0 || minShipDate.getDay() == 6)) {
              nextDayDelivery = false;
            }
          }
          var minShipDateMonth = new Date(minShipDate);
          minShipDateMonth = minShipDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var shipdays = minShipDateMonth + " " + minShipDate.getDate();
          // calculate delivery dates
          var minDelDate = new Date(minShipDate);
          var maxDelDate = new Date(minShipDate);
          // find weekends and calculate shipping days
          for (var i = 1; i <= parseInt(country_min_del_days); ) {
            minDelDate.setDate(minDelDate.getDate() + parseInt(1));
            if (!(minDelDate.getDay() == 0 || minDelDate.getDay() == 6)) {
              i++;
            }
          }

          for (var i = 1; i <= parseInt(country_max_del_days); ) {
            maxDelDate.setDate(maxDelDate.getDate() + parseInt(1));
            if (!(maxDelDate.getDay() == 0 || maxDelDate.getDay() == 6)) {
              i++;
            }
          }
          deliveryBy(minDelDate, maxDelDate, true);
          var minDelDateMonth = new Date(minDelDate);
          var maxDelDateMonth = new Date(maxDelDate);
          var minDelDateMonthStr = minDelDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var maxDelDateMonthStr = maxDelDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var deliverydaysstr =
            minDelDateMonthStr +
            " " +
            minDelDate.getDate() +
            "-" +
            maxDelDateMonthStr +
            " " +
            maxDelDate.getDate();

          $(".orderdate").html(orderDate);
          $(".shippingdate").html(shipdays);
          $(".deliverydate").html(deliverydaysstr);
          $(".rapiddelivery-div").show();
          $(".shipping_progress").show();
          $(".delivery_within_txt").show();
        } else {
          if (
            $("input[name='properties[_min_ready_to_ship_days]']").length > 0
          ) {
            var minshipdays = $(
              "input[name='properties[_min_ready_to_ship_days]']"
            ).val();
            var maxshipdays = $(
              "input[name='properties[_max_ready_to_ship_days]']"
            ).val();
          } else {
            //need to change
            var minshipdays = $("#product_min_ship_days").val();
            var maxshipdays = $("#product_max_ship_days").val();
          }
          var minShipDate = new Date();
          var maxShipDate = new Date();
          for (var i = 1; i <= parseInt(minshipdays); ) {
            minShipDate.setDate(minShipDate.getDate() + parseInt(1));
            if (!(minShipDate.getDay() == 0 || minShipDate.getDay() == 6)) {
              i++;
            }
          }
          for (var i = 1; i <= parseInt(maxshipdays); ) {
            maxShipDate.setDate(maxShipDate.getDate() + parseInt(1));
            if (!(maxShipDate.getDay() == 0 || maxShipDate.getDay() == 6)) {
              i++;
            }
          }
          var minShipDateMonth = new Date(minShipDate);
          var maxShipDateMonth = new Date(maxShipDate);
          minShipDateMonth = minShipDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          maxShipDateMonth = maxShipDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var shipdays =
            minShipDateMonth +
            " " +
            minShipDate.getDate() +
            "-" +
            maxShipDateMonth +
            " " +
            maxShipDate.getDate();
          for (var i = 1; i <= parseInt(country_min_del_days); ) {
            minShipDate.setDate(minShipDate.getDate() + parseInt(1));
            if (!(minShipDate.getDay() == 0 || minShipDate.getDay() == 6)) {
              i++;
            }
          }
          for (var i = 1; i <= parseInt(country_max_del_days); ) {
            maxShipDate.setDate(maxShipDate.getDate() + parseInt(1));
            if (!(maxShipDate.getDay() == 0 || maxShipDate.getDay() == 6)) {
              i++;
            }
          }
          deliveryBy(minShipDate, maxShipDate, true);
          var minDelDateMonth = new Date(minShipDate);
          var maxDelDateMonth = new Date(maxShipDate);
          var minDelDateMonthStr = minDelDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var maxDelDateMonthStr = maxDelDateMonth.toLocaleString("en-US", {
            month: "short",
          });
          var deliverydaysstr =
            minDelDateMonthStr +
            " " +
            minShipDate.getDate() +
            "-" +
            maxDelDateMonthStr +
            " " +
            maxShipDate.getDate();

          $(".orderdate").html(orderDate);

          $(".shippingdate").html(shipdays);
          $(".deliverydate").html(deliverydaysstr);
          if (
            !$("div[data-id='" + $('select[name="id"]').val() + "']").hasClass(
              "soldout"
            )
          ) {
            $(".prod_del_info").show();
            $(".shipping_progress").show();
            $(".delivery_within_txt").show();
          } else {
            $(".prod_del_info").hide();
            $(".shipping_progress").hide();
            $(".delivery_within_txt").hide();
          }
        }
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if(window.location.pathname.indexOf("/products") != -1)
  {
    shippingProgress(false);
    shippingRates();
  }
});
